import { MarkdownManager } from '@tiptap/markdown';

import { extensions, markedOptions } from '@eluve/tiptap-extensions';

// The single @tiptap/markdown engine instance shared across markdown-utils
// (ENG-4659). Both normalizeMarkdown (markdown → canonical markdown) and
// markdownToTiptapJson (markdown → Tiptap JSON) go through this ONE manager, built
// with the editor's own extensions + markedOptions — so every markdown↔JSON
// conversion in this lib matches the live editor's serialization.
//
// Built lazily and memoized: construction (extension registration) is the
// likeliest failure point, so it happens on first use inside callers' try/catch —
// a throw surfaces as the caller's `{ ok: false }` instead of crashing module
// import (api-nest boot / the diff bundle).
let markdownManager: MarkdownManager | null = null;

export const getMarkdownManager = (): MarkdownManager => {
  if (markdownManager === null) {
    markdownManager = new MarkdownManager({ extensions, markedOptions });
  }
  return markdownManager;
};
